import {
  NOT
} from '../../../../../lib/Boolean.lib';
import Definition, {
  DEFINITION_CATEGORY__JOB_PREFERENCE,
  ID__TAG__JOB_PREFERENCE__COMPANIES_AVOID,
  ID__TAG__JOB_PREFERENCE__COMPANIES_TARGET,
  ID__TAG__JOB_PREFERENCE__SCHOOLS_AVOID,
  ID__TAG__JOB_PREFERENCE__SCHOOLS_TARGET
} from '../../../../../lib/Definition';
import {
  Fun
} from '../../../../../lib/Function.lib';
import {
  Obj
} from '../../../../../lib/Object.lib';
import {
  joinKeyName
} from '../../../../../lib/String.lib';
import Chip from '../../../../Layout/Wrappers/Chip';
import Fieldset from '../../../../Layout/Wrappers/Fieldset';
import {
  getControllerJobEdit
} from '../../JobEdit';

export default function ConfigureHaveJobPreferences({
  values = [],
  onChange = Fun
}) {
  const CURRENT__JOB = Obj(
    getControllerJobEdit().state
  );
  const TAGS__JOB_PREFERENCE = Definition.get(DEFINITION_CATEGORY__JOB_PREFERENCE);
  const TAGS__FILTERED__JOB_PREFERENCE = TAGS__JOB_PREFERENCE.filter(
    (tag) => (
      (
        tag.id === ID__TAG__JOB_PREFERENCE__SCHOOLS_TARGET &&
        CURRENT__JOB.jobPreferences?.schools?.target?.length > 0
      ) ||
      (
        tag.id === ID__TAG__JOB_PREFERENCE__SCHOOLS_AVOID &&
        CURRENT__JOB.jobPreferences?.schools?.avoid?.length > 0
      ) ||
      (
        tag.id === ID__TAG__JOB_PREFERENCE__COMPANIES_TARGET &&
        CURRENT__JOB.jobPreferences?.companies?.target?.length > 0
      ) ||
      (
        tag.id === ID__TAG__JOB_PREFERENCE__COMPANIES_AVOID &&
        CURRENT__JOB.jobPreferences?.companies?.avoid?.length > 0
      )
    )
  );
  console.debug({
    CURRENT__JOB,
    TAGS__JOB_PREFERENCE,
    TAGS__FILTERED__JOB_PREFERENCE,
    values
  });
  const _onClick = (id) => (event) => {
    event.preventDefault();
    let tagIds = [];
    if (values.includes(id)) {
      tagIds = values.filter((value) => value !== id);
    }
    else {
      tagIds = [...values, id];
    }
    const tags = TAGS__FILTERED__JOB_PREFERENCE.filter(
      (tags) => tagIds.includes(tags.id)
    ).map(
      (option) => ({
        ...option,
        key: DEFINITION_CATEGORY__JOB_PREFERENCE,
        selected: true
      })
    );
    onChange(tagIds, tags);
  }
  return (
    <Fieldset
      acl={TAGS__FILTERED__JOB_PREFERENCE.length > 0}
      title='Job Preferences'
    >
      {TAGS__FILTERED__JOB_PREFERENCE.map((
        option,
        index,
        array,
        YES__SELECTED = values.includes(option.id)
      ) => {
        return (
          <Chip
            outlined={NOT(YES__SELECTED)}
            color={YES__SELECTED ? 'secondary' : 'default'}
            key={joinKeyName(['chip', 'job_preference', option.id, index])}
            label={option.label}
            onClick={_onClick(option.id)}
          />
        )
      })}
    </Fieldset>
  );
}
